import { render, staticRenderFns } from "./NameAndDescriptionStep.vue?vue&type=template&id=3fba31f0&scoped=true"
import script from "./NameAndDescriptionStep.vue?vue&type=script&lang=ts"
export * from "./NameAndDescriptionStep.vue?vue&type=script&lang=ts"
import style0 from "./NameAndDescriptionStep.vue?vue&type=style&index=0&id=3fba31f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba31f0",
  null
  
)

export default component.exports